import { subPhotoPlaceholderPNG, subPhotoPNG } from "swing-assets";

export type SubResponse = {
  "sub/id"?: string;
  "sub/name"?: string;
  "sub/phone"?: string;
  "sub/email"?: string;
  "google/email"?: string;
  "sub/photo"?: string;
  "sub/preferred-sub-eligible"?: boolean;
  "sub/is-valid-credential"?: boolean;
  "sub/teacher-blocked"?: boolean;
  "sub/teacher-favorited"?: boolean;
  "sub/school-favorited"?: boolean;
  "sub/is-swing-hero?"?: boolean;
  "conflict/conflicting-commitment?"?: boolean;
  "sub/languages"?: Array<string>;
  "sub/district-days-worked"?: number;
  isInternalSub?: boolean;
  stats?: {
    isSwingHero?: boolean;
  };
};

export class SubModel {
  private sub;

  constructor(sub: SubResponse = {}) {
    this.sub = sub;
  }

  // TODO: if undefined, throw? does api layer guarantee a value?
  //       same questions apply for all required fields on any model.
  get id() {
    return this.sub?.["sub/id"] || "";
  }

  get name() {
    return this.sub?.["sub/name"] || "";
  }

  get phoneNumber() {
    return this.sub?.["sub/phone"] || "";
  }

  get email() {
    return this.sub?.["sub/email"] || this.sub?.["google/email"] || "";
  }

  get photo() {
    const photo = this.sub?.["sub/photo"];
    if ("placeholder://sub-photo.png" === photo) {
      return subPhotoPNG;
    }
    return photo || subPhotoPlaceholderPNG;
  }

  get isEligible() {
    return this.sub?.["sub/preferred-sub-eligible"] || false;
  }

  get isCredentialed() {
    return this.sub?.["sub/is-valid-credential"] || false;
  }

  get isSwingHero() {
    return this.sub?.stats?.isSwingHero || this.sub?.["sub/is-swing-hero?"] || false;
  }

  get isTeacherBlocked() {
    return this.sub?.["sub/teacher-blocked"] || false;
  }

  get isTeacherFavorited() {
    return this.sub?.["sub/teacher-favorited"] || false;
  }

  get isSchoolFavorited() {
    return this.sub?.["sub/school-favorited"] || false;
  }

  get isInternal() {
    return this.sub?.isInternalSub || false;
  }

  get hasConflict() {
    return this.sub?.["conflict/conflicting-commitment?"] || false;
  }
  get languages() {
    return this.sub?.["sub/languages"] || [];
  }
  get districtDaysWorked() {
    return this.sub?.["sub/district-days-worked"] || 0;
  }
  get poolSortScore() {
    let score = 0;

    if (this.isSwingHero) score += 1;
    if (this.isSchoolFavorited) score += 1;
    if (this.districtDaysWorked > 0) score += 1;
    if (this.languages.length > 0) score += 1;
    return score;
  }
}
